import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function neverEmptyString(input: string | undefined | null): string | undefined {
  return input === null || input === undefined || input.trim() === '' ? undefined : input;
}

export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function randomColor(): string {
  const colorHexes = ["FF0000", "00FF00", "FFFF00", "0000FF"]; // Hex values for red, green, yellow, blue
  const randomIndex = Math.floor(Math.random() * colorHexes.length);
  return colorHexes[randomIndex];
}

export function rgbaToNumber(r: number, g: number, b: number, a: number) {
  return ((r & 0xFF) << 24) |
         ((g & 0xFF) << 16) |
         ((b & 0xFF) << 8)  |
         (a & 0xFF);
}

export function numberToRgba(num: number) {
  const unsigned = num >>> 0;
  return {
    r: (unsigned >> 24) & 0xFF,
    g: (unsigned >> 16) & 0xFF,
    b: (unsigned >> 8)  & 0xFF,
    a: unsigned & 0xFF,
  };
}

export function numberToRgbaString(num: number) {
  const { r, g, b, a } = numberToRgba(num);
  return `rgba(${r}, ${g}, ${b}, ${a / 255})`;
}

export function hexStringWithAlphaToNumber(hex: string, alpha: number) {
  const clean = hex.replace('#', '');
  if (clean.length !== 6) throw new Error("Invalid hex string");

  const r = parseInt(clean.slice(0, 2), 16);
  const g = parseInt(clean.slice(2, 4), 16);
  const b = parseInt(clean.slice(4, 6), 16);

  return rgbaToNumber(r, g, b, alpha) >>> 0;
}

export function hexStringWithFloatAlphaToNumber(hex: string, alpha: number) {
  return hexStringWithAlphaToNumber(hex, Math.round(alpha * 255));
}

export function numberToHexStringAndAlpha(num: number) {
  const { r, g, b, a } = numberToRgba(num);
  const hex = `#${r.toString(16).padStart(2, '0')}${g
    .toString(16)
    .padStart(2, '0')}${b.toString(16).padStart(2, '0')}`.toUpperCase();
  return { hex, alpha: a };
}
